import { useParticipant } from "@videosdk.live/react-sdk";
import { useEffect, useRef, useState } from "react";
import { CornerDisplayName } from "../utils/common";

export function ParticipantView({ participantId }) {
  const {
    displayName,
    webcamStream,
    micStream,
    webcamOn,
    micOn,
    isLocal,
    mode,
  } = useParticipant(participantId);

  const micRef = useRef(null);
  const webcamRef = useRef(null);
  const [mouseOver, setMouseOver] = useState(false);



  // Handle participant microphone
  useEffect(() => {
    const audio = micRef.current;

    if (!audio) return;

    if (micOn && micStream?.track) {
      const mediaStream = new MediaStream([micStream.track]);

      audio.srcObject = mediaStream;

      audio
        .play()
        .catch((error) => {
          console.error("Audio play failed:", error);
        });
    } else {
      audio.srcObject = null;
    }

    return () => {
      audio.pause();
      audio.srcObject = null;
    };
  }, [micStream, micOn]);

  // Handle participant webcam
  useEffect(() => {
    const video = webcamRef.current;

    if (!video) {
      console.log("VIDEO REF NOT AVAILABLE");
      return;
    }

    if (!webcamOn || !webcamStream?.track) {
      console.log("No webcam track:", {
        participantId,
        displayName,
        webcamOn,
        webcamStream,
      });

      video.pause();
      video.srcObject = null;

      return;
    }

    const track = webcamStream.track;

    console.log("REMOTE TRACK DETAILS:", {
      participantId,
      displayName,
      kind: track.kind,
      readyState: track.readyState,
      enabled: track.enabled,
      muted: track.muted,
    });

    const mediaStream = new MediaStream([track]);

    console.log("MEDIA STREAM DETAILS:", {
      tracks: mediaStream.getTracks(),
      videoTracks: mediaStream.getVideoTracks(),
    });

    video.srcObject = mediaStream;

    video
      .play()
      .then(() => {
        console.log("VIDEO PLAY SUCCESS:", {
          participantId,
          displayName,
          videoWidth: video.videoWidth,
          videoHeight: video.videoHeight,
          readyState: video.readyState,
        });
      })
      .catch((error) => {
        console.error("VIDEO PLAY FAILED:", error);
      });

    return () => {
      video.pause();
      video.srcObject = null;
    };
  }, [
    participantId,
    displayName,
    webcamStream,
    webcamOn,
  ]);

  

  return (
    <div
      onMouseEnter={() => {
        setMouseOver(true);
      }}
      onMouseLeave={() => {
        setMouseOver(false);
      }}
      className="h-full w-full bg-gray-750 relative overflow-hidden rounded-lg video-cover"
    >
      {/* Participant audio */}
      <audio
        ref={micRef}
        autoPlay
        playsInline
        muted={isLocal}
      />

      {/* Participant video */}
      <video
        ref={webcamRef}
        autoPlay
        playsInline
        muted
        className="w-full h-full object-cover"
        onLoadedMetadata={(event) => {
          console.log("VIDEO METADATA LOADED:", {
            participantId,
            displayName,
            width: event.currentTarget.videoWidth,
            height: event.currentTarget.videoHeight,
            readyState: event.currentTarget.readyState,
          });
        }}
        onCanPlay={() => {
          console.log("VIDEO CAN PLAY:", {
            participantId,
            displayName,
          });
        }}
        onPlaying={() => {
          console.log("VIDEO PLAYING:", {
            participantId,
            displayName,
          });
        }}
        onError={(event) => {
          console.error("VIDEO ERROR:", {
            participantId,
            displayName,
            error: event.currentTarget.error,
          });
        }}
      />

      {/* Avatar when webcam is OFF */}
      {!webcamOn && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="z-10 flex items-center justify-center rounded-full bg-gray-800 2xl:h-[92px] h-[52px] 2xl:w-[92px] w-[52px]">
            <p className="text-2xl text-white">
              {String(displayName).charAt(0).toUpperCase()}
            </p>
          </div>
        </div>
      )}

      {/* Participant name / controls */}
      <CornerDisplayName
        {...{
          isLocal,
          displayName,
          micOn,
          webcamOn,
          isPresenting: false,
          participantId,
          mouseOver,
        }}
      />
    </div>
  );
}